const isProd = window.location.hostname.endsWith('.com')

export const BACKOFFICE_URL = isProd
  ? 'https://backoffice.revolut.com'
  : 'https://backoffice.revolut.codes'

export const CONFLUENCE_URL = 'https://revolut.atlassian.net'

export const IDAVE_URL = isProd ? 'https://id.revolut.com' : 'https://id.revolut.codes'

export const IDAVE_CLIENT_ID = isProd
  ? '080fd2df-af57-4b58-b06f-c79da1105aab'
  : '146207fc-9a3f-4a78-9c90-9aa9d264c761'
